import { BaseApiModel } from './BaseApiModel';

export class Manufacturer extends BaseApiModel {
  public contractIds: Array<string>;
  public name: string;
  public createdAt: Date;
  public modifiedAt: Date;
}
